import React from 'react'

import HasDataBadge from '#/components/badges/HasDataBadge'

const TypeHasDataBadge = ({ value }) => {
  if (!value) return <span>-</span>
  return <HasDataBadge value={value} />
}
export default TypeHasDataBadge
